export default __webpack_public_path__ + "static/media/newsExplorer.a81d34ee.JPG";